import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SettingsHeader } from "~/components/layout/settings-header";
import { Button } from "~/components/ui/button";
import { api } from "~/lib/api";

interface MollieSearchParams {
  code?: string;
  state?: string;
  error?: string;
  error_description?: string;
}

export const Route = createFileRoute(
  "/_main/settings/_layout/integrations/mollie",
)({
  component: Mollie,
  validateSearch: (search: Record<string, unknown>): MollieSearchParams => {
    return {
      code: search.code as string,
    };
  },
});

function Mollie() {
  const { t } = useTranslation("common");
  const { code } = Route.useSearch();
  const navigate = useNavigate();

  const { mutate: exchangeCode } =
    api.mollie.exchangeCodeForAccessToken.useMutation();

  const { mutate: createPayment } = api.mollie.createPayment.useMutation();

  useEffect(() => {
    if (code) {
      exchangeCode(code);
      void navigate({ to: "/settings/integrations/mollie" });
    }
  }, [code, exchangeCode, navigate]);
  return (
    <>
      <SettingsHeader title={t("mollie")} />
      <Button onClick={() => createPayment()}>Create payment</Button>
    </>
  );
}
